import {
  StyledEmptyStateOverlay,
  StyledEmptyStateOverlayActions,
  StyledEmptyStateOverlayDescription,
  StyledEmptyStateOverlayHeader
} from './EmptyStateOverlay.style';

const EmptyStateOverlay = ({
  Background,
  Illustration,
  Title,
  Description,
  Actions
}) => {
  return (
    <StyledEmptyStateOverlay background={Background}>
      {Illustration && <Illustration />}
      {Title && (
        <StyledEmptyStateOverlayHeader>{Title}</StyledEmptyStateOverlayHeader>
      )}
      {Description && (
        <StyledEmptyStateOverlayDescription>
          {Description}
        </StyledEmptyStateOverlayDescription>
      )}
      {Actions && (
        <StyledEmptyStateOverlayActions>
          {Actions}
        </StyledEmptyStateOverlayActions>
      )}
    </StyledEmptyStateOverlay>
  );
};

export default EmptyStateOverlay;
